import React, {Fragment, useContext, useEffect, useState} from 'react'
import {Dropdown, OverlayTrigger, Stack, Tooltip} from 'react-bootstrap'
import {useLocation, useNavigate} from 'react-router-dom'
import {KTCardBody, KTIcon} from '../../../../../_metronic/helpers'
import {formatDateToDMY} from '../../../../helpers/dateFunctions'
import {deleteDocument, downloadAsZip, getDocuments} from '../../../../services/documentos'
import {fetchMenuActionsByRole, fetchSubMenuByUrl} from '../../../../services/menu'
import {showCancellationMessage, showMessage} from '../../../../shared/Alerts'
import {ModernPagination} from '../../../../shared/ModernPagination'
import SortableTableHeader from '../../../../shared/SortableTableHeader'
import {UsersListLoading} from '../../../apps/user-management/users-list/components/loading/UsersListLoading'
import {useAuth2} from '../../../authv2/Auth2Provider'
import {CustomTooltip} from '../../../generales_component/CustomTooltip'
import {ListaSecciones} from '../../usuario/pages/secciones/ListaSecciones'
import {PartnerContext} from '../PartnerContexts'

const DocumentsTable = () => {
  const [sortBy, setSortBy] = useState({columnName: '', sortDirection: ''})
  const [isLoading, setLoadingStatus] = useState(false)
  const [totalPages, setTotalPages] = useState(1)

  const [lista, setLista] = useState([])
  const [selecto, setSelecto] = useState(0)
  const [mnuevo, setMnuevo] = useState(false)
  const [nuevo, setNuevo] = useState('')

  const {
    activeOnly,
    idProceso,
    state,
    searchTerm,
    entryDateFrom,
    entryDateTo,
    unidad,
    currentPage,
    setCurrentPage,
  } = useContext(PartnerContext)

  const navigate = useNavigate()

  const iconsData = [
    {
      iconName: 'verify',
      title: 'Borrador',
      stateName: 'borrador',
      color: '#f39c12', // Orange
    },
    {
      iconName: 'security-user',
      title: 'Enviado',
      stateName: 'completado',
      color: '#2ecc71', // Green
    },
    {
      iconName: 'security-user',
      title: 'Pendiente',
      stateName: 'pendiente',
      color: '#3c50e7',
    },
  ]
  const location = useLocation()
  const {selectedRole} = useAuth2()
  const [permissions, setPermissions] = useState<string[]>([])

  useEffect(() => {
    const fetchPermissions = async () => {
      const response = await fetchMenuActionsByRole(selectedRole)
      if (response.success) {
        const currentPath = location.pathname
        console.log('currentpath' + JSON.stringify(currentPath))
        const subMenuResponse = await fetchSubMenuByUrl(currentPath)
        if (subMenuResponse.success) {
          console.log('PERMISOS' + JSON.stringify(subMenuResponse))
          const subMenuId = subMenuResponse.data.id_hijo
          const permissionsForSubMenu =
            response.data.find((item: any) => item.subMenuId === subMenuId)?.acciones || []
          setPermissions(permissionsForSubMenu)
        }
      }
    }

    fetchPermissions()
  }, [selectedRole])

  useEffect(() => {
    if (!idProceso) {
      showMessage('info', 'Importante', 'Seleccione un proceso')
    } else {
      setLoadingStatus(true)
      refetchData({
        activeOnly: activeOnly,
        sheetStates: state,
        id_proceso: idProceso,
        searchQuery: searchTerm,
        entryDateFrom: entryDateFrom,
        entryDateTo: entryDateTo,
        sortBy: sortBy.columnName,
        sortOrder: sortBy.sortDirection,
        unidad: unidad,
        page: currentPage,
      })
    }
  }, [
    sortBy,
    activeOnly,
    state,
    idProceso,
    entryDateFrom,
    entryDateTo,
    searchTerm,
    unidad,
    currentPage,
  ])

  const refetchData = (options: any) => {
    setLoadingStatus(true)

    getDocuments(options)
      .then((response) => {
        if (response.success) {
          setLoadingStatus(false)
          setLista(response?.data)
          const totalPages = response?.totalPages
            ? response?.totalPages === 0
              ? 1
              : response?.totalPages
            : 1
          setTotalPages(totalPages)
          setCurrentPage(response?.page)
        } else {
          console.log(response)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
  }

  const handleCancellation = (id: string) => {
    showCancellationMessage().then((result) => {
      if (result.isConfirmed) {
        deleteDocument(id)
          .then((response) => {
            if (response.success) {
              refetchData({
                activeOnly: activeOnly,
                id_proceso: idProceso,
                sheetStates: state,
                searchQuery: searchTerm,
                entryDateFrom: entryDateFrom,
                entryDateTo: entryDateTo,
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }
    })
  }

  const handleUpdate = (id: any) => {
    navigate(`/configuracion/enviodocumentos/${id}`)
  }

  const handleView = (id: any) => {
    navigate(`/seguimiento/documentos/detalle/${id}`)
  }

  const handleDownloadAsZip = (id: string) => {
    downloadAsZip(id)
      .then((response) => {
        if (response.success) {
          const link = document.createElement('a')
          link.href = response.data
          link.download = 'carga'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          showMessage('success', '¡Buen trabajo!', response.message)
        } else {
          console.log(response)
          showMessage('error', 'Hubo un error', response.error)
        }
      })
      .catch((error) => {
        console.log(error)
        showMessage('error', 'Hubo un error', error.message)
      })
  }

  // Custom Toggle Component
  const CustomToggle = React.forwardRef(({onClick}: any, ref: any) => (
    <button
      ref={ref}
      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
      title='Visualizar ficha'
      onClick={(e) => {
        e.preventDefault()
        onClick(e)
      }}
    >
      <KTIcon iconName='dots-square-vertical' className='fs-3' />
    </button>
  ))

  const handleSort = (columnName: string, sortDirection: string) => {
    console.log('Sorting column:', columnName, 'Direction:', sortDirection)
    setSortBy({columnName, sortDirection})
    console.log('SortBy state updated:', sortBy)
  }

  return (
    <>
      <KTCardBody className='py-4'>
        <div className='table-responsive'>
          <table className='table align-middle table-row-bordered fs-6 table-hover'>
            <thead>
              <tr className='text-start fw-bolder fs-7 text-uppercase gs-0 bg-primary text-white'>
                <td className='text-start p-3'>Unidad</td>
                <td className='text-start'>Codigo</td>
                <SortableTableHeader
                  label='Nombre de Paquete'
                  columnName='nombre'
                  handleSort={handleSort}
                  activeColumn={sortBy.columnName}
                  labelStyle={{color: '#ffffff'}}
                />
                <SortableTableHeader
                  label='Proceso'
                  columnName='idProceso'
                  handleSort={handleSort}
                  activeColumn={sortBy.columnName}
                  labelStyle={{color: '#ffffff'}}
                />
                <SortableTableHeader
                  label='Fecha'
                  columnName='createdAt'
                  handleSort={handleSort}
                  activeColumn={sortBy.columnName}
                  labelStyle={{color: '#ffffff'}}
                />
                <SortableTableHeader
                  label='Estado'
                  columnName='estadoCarga'
                  handleSort={handleSort}
                  activeColumn={sortBy.columnName}
                  labelStyle={{color: '#ffffff'}}
                />
                <td className='text-start' title='Usuarios que firmaron'>
                  Usu. firm
                </td>
                <td className='text-start' style={{paddingLeft: '4rem'}}>
                  Resumen
                </td>
                <td className='text-end p-3'>Opciones</td>
              </tr>
            </thead>
            <tbody className='text-gray-600 fw-bold'>
              {lista.length > 0 ? (
                lista?.map((item: any, index: any) => {
                  const hasSomeDenied = item?.idFiles?.some((file: any) => {
                    if (file.detalle_niveles == null || file.detalle_niveles?.length === 0) {
                      return false
                    } else {
                      return file.detalle_niveles?.some(
                        (level: any) => level.detalle?.estado === 'rechazado'
                      )
                    }
                  })

                  return (
                    <Fragment key={item._id}>
                      <tr>
                        <td className='text-start min-w-250px p-3'>
                          {item.unidad && item.unidad.length > 0
                            ? item.unidad.map((u: any) => u.DesUnid).join(', ')
                            : 'Sin Unidad'}
                        </td>
                        <td className='text-start min-w-150px p-3'>
                          {item.codigo ?? 'Sin Codigo'}
                        </td>
                        <td className='text-start min-w-250px p-2'>{item.nombre}</td>
                        <td className='text-start min-w-200px p-2'>{item.idProceso.nombre}</td>
                        <td className='text-start min-w-150px p-2'>
                          {formatDateToDMY(item.createdAt)}
                        </td>
                        <td className='text-start min-w-100px p-2'>
                          <span
                            style={{
                              backgroundColor: `${
                                iconsData.find((e) => e.stateName === item.estadoCarga)?.color
                              }`,
                              color: 'white',
                              padding: '0.2em 0.5em',
                              borderRadius: '0.25rem',
                              marginRight: '0.5em',
                              fontSize: '0.8em',
                            }}
                          >
                            {iconsData.find((e) => e.stateName === item.estadoCarga)?.title}
                          </span>
                        </td>

                        <td className='text-start min-w-100px p-2'>
                          {item.usersCompletedSigned} / {item.totalUsers}
                        </td>

                        <td className='text-start min-w-200px p-2'>
                          <OverlayTrigger
                            placement='left'
                            overlay={
                              <Tooltip id='pending-tooltip'>Documentos pendientes de firma</Tooltip>
                            }
                          >
                            <span
                              style={{
                                backgroundColor: '#f39c12',
                                color: 'white',
                                padding: '0.2em 0.5em',
                                borderRadius: '0.25rem',
                                marginRight: '0.5em',
                                fontSize: '0.8em',
                                width: '4em',
                                display: 'inline-block',
                                textAlign: 'center',
                              }}
                            >
                              {item.summary.pending}
                            </span>
                          </OverlayTrigger>

                          <OverlayTrigger
                            placement='top'
                            overlay={<Tooltip id='pending-tooltip'>Documentos firmados</Tooltip>}
                          >
                            <span
                              style={{
                                backgroundColor: '#2ecc71',
                                color: 'white',
                                padding: '0.2em 0.5em',
                                borderRadius: '0.25rem',
                                marginRight: '0.5em',
                                fontSize: '0.8em',
                                width: '4em',
                                display: 'inline-block',
                                textAlign: 'center',
                              }}
                            >
                              {item.summary.signed}
                            </span>
                          </OverlayTrigger>

                          <OverlayTrigger
                            placement='right'
                            overlay={<Tooltip id='pending-tooltip'>Documentos rechazados</Tooltip>}
                          >
                            <span
                              style={{
                                backgroundColor: '#e74c3c',
                                color: 'white',
                                padding: '0.2em 0.5em',
                                borderRadius: '0.25rem',
                                marginRight: '0.5em',
                                fontSize: '0.8em',
                                width: '4em',
                                display: 'inline-block',
                                textAlign: 'center',
                              }}
                            >
                              {item.summary.rejected}
                            </span>
                          </OverlayTrigger>
                        </td>

                        <td className='text-end d-flex align-self-end justify-content-end p-1'>
                          {item.deniedDocs > 0 && (
                            <CustomTooltip
                              className='btn btn-icon btn-danger btn-sm'
                              icon='information-4'
                              placement='top'
                              children={`Hay ${item.deniedDocs} documentos rechazados dentro de los niveles de aprobación`}
                            />
                          )}
                          <Stack direction='horizontal' gap={1}>
                            {permissions.includes('Ver Detalle') && (
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                title='Ver detalle'
                                onClick={() => handleView(item._id)}
                              >
                                <KTIcon iconName='eye' className='fs-3' />
                              </button>
                            )}
                            {(permissions.includes('Borrador') &&
                              item.estadoCarga === 'borrador') ||
                            hasSomeDenied ? (
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                title='Editar'
                                onClick={() => handleUpdate(item._id)}
                              >
                                <KTIcon iconName='pencil' className='fs-3' />
                              </button>
                            ) : (
                              <></>
                            )}
                            {permissions.includes('Opciones Documento') && (
                              <Dropdown>
                                <Dropdown.Toggle as={CustomToggle} />

                                <Dropdown.Menu className='fs-7'>
                                  <Dropdown.Item onClick={() => handleCancellation(item._id)}>
                                    Cancelar Carga
                                  </Dropdown.Item>
                                  <Dropdown.Item onClick={() => handleDownloadAsZip(item._id)}>
                                    Descargar Documentos
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            )}
                          </Stack>
                        </td>
                      </tr>
                      {item._id === selecto ? (
                        <ListaSecciones
                          id={selecto}
                          mnuevo={mnuevo}
                          setMnuevo={setMnuevo}
                          nuevo={nuevo}
                        />
                      ) : null}
                    </Fragment>
                  )
                })
              ) : (
                <tr>
                  <td colSpan={5}>
                    <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                      No matching records found
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* <UsersListPagination /> */}
        {/* <Pagination
          links={generatePaginationLinks(currentPage, totalPages)}
          currentPage={currentPage}
          isLoading={isLoading}
          onPageChange={handlePageChange}
        /> */}

        <ModernPagination
          totalPages={totalPages}
          currentPage={currentPage}
          isLoading={isLoading}
          onPageChange={handlePageChange}
          siblings={5}
        />
        {isLoading && <UsersListLoading />}
      </KTCardBody>
    </>
  )
}

export {DocumentsTable}
